// App.js
import React, { useState, useEffect } from 'react';
import { Box, Container, Grid } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import SourdoughCalculator from './components/SourdoughCalculator';
import 'modern-normalize/modern-normalize.css';


const theme = createTheme({
  palette: {
    primary: {
      main: '#8B4513' // Dark brown
    },
    background: {
      default: '#f7f0e7' // Light warm background
    }
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: '12px',
            backgroundColor: '#fdfdf7'
          }
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
          backgroundColor: '#8B4513',
          ':hover': { backgroundColor: '#5A2F0D' }
        }
      }
    }
  }
});

function App() {

  // Set background globally when component mounts
  useEffect(() => {
    document.documentElement.style.setProperty('--background-color', theme.palette.background.default);
  }, [theme]);

  // Keep the dough state in parent so GPTChat can use it
  const [doughData, setDoughData] = useState({
    flour: '500',
    protein: '12',
    starter: '100',
    starterHydration: '100',
    doughHydration: '70',
    isFahrenheit: true,
    temperature: '72',
    notes: '',
    // Calculated
    totalFlourOutput: 0,
    waterOutput: 0,
    starterOutput: 0,
    saltOutput: 0,
    bulkFermentationTime: 0,
    coldProofTime: 0
  });

  return (
    <ThemeProvider theme={theme}>
      <Box // ✅ Use Box instead of div
        sx={{
          backgroundColor: theme.palette.background.default,
          minHeight: '100vh', // Ensures at least full viewport height
          display: 'flex',
          flexDirection: 'column', // Ensures content stacks properly
          justifyContent: 'flex-start', // Align content at the top
          alignItems: 'center',
          padding: { xs: 1, sm: 5 }, // ✅ Now applies responsive padding correctly
          width: '100vw',
          overflowX: 'hidden', // Prevents horizontal scrolling
          overflowY: 'auto' // Allows content to expand properly
        }}
      >
        <Container maxWidth="md">
          <Grid container justifyContent="center">
            <Grid item xs={12} sm={10} md={8}>
              <SourdoughCalculator doughData={doughData} setDoughData={setDoughData} />
            </Grid>
          </Grid>
        </Container>
      </Box>
    </ThemeProvider>
  );
  
}

export default App;
